var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "msp-legend-item",
      style: {
        borderColor: _vm.color,
      },
      attrs: { title: _vm.labelText },
    },
    [
      _c("span", {
        staticClass: "msp-legend-item__circle",
        style: {
          backgroundColor: _vm.color,
        },
      }),
      _vm._v(" " + _vm._s(_vm.labelText) + " "),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }